import axios from 'axios'
import humps from 'humps'
import Qs from 'qs'

import { getBaseURL, getBaseURLTextAnalysis } from 'lib/utility/GetBaseUrl'
import transformResponse from 'api/Utility/TransformResponse'
import responseHandler from 'api/Utility/AxiosErrorHandler'
import apiHeaders from 'api/Utility/ApiHeaders'
import { isProduction } from 'lib/utility/ApplicationConfig'

const jsonHeaderData = apiHeaders.getJsonData()

type HeaderProps = {
  'x-api-token'?: string
}

type AxiosInitializerProps = {
  token?: any
  transformReqConfig?: boolean
  transformResConfig?: boolean
  paramsSerializerConfig?: boolean
  signal?: any
  tool?: string
  encode?: boolean
}

const AxiosInitializer = ({
  token,
  transformReqConfig = false,
  transformResConfig = true,
  paramsSerializerConfig = false,
  signal,
  tool,
  encode = true,
}: AxiosInitializerProps) => {
  const ENDPOINT =
    tool === 'text_analysis'
      ? getBaseURLTextAnalysis()
      : `${getBaseURL()}/api/v2/`

  const headers: HeaderProps = {
    'x-api-token': tool === 'text_analysis' ? token : `Bearer ${token}`,
    ...jsonHeaderData,
  }

  const isProd = isProduction()

  if (isProd && !tool) {
    delete headers['x-api-token']
  }

  const customAxios = axios.create({
    baseURL: ENDPOINT,
    headers: headers,
    signal,
    ...(transformResConfig && {
      transformResponse: [
        function (response) {
          return transformResponse(response)
        },
      ],
    }),
    ...(transformReqConfig && {
      transformRequest: [
        function (data) {
          return JSON.stringify(humps.decamelizeKeys(data, { separator: '-' }))
        },
      ],
    }),
    ...(paramsSerializerConfig && {
      paramsSerializer: function (params: any) {
        return Qs.stringify(params, {
          arrayFormat: 'brackets',
          encode,
        })
      },
    }),
  })

  customAxios.interceptors.response.use(
    (response) => responseHandler.axiosResponseHandler(response),
    (error) => responseHandler.axiosErrorHandler(error),
  )

  return customAxios
}

export default AxiosInitializer
